import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images
import imageWF from './images/wf_symbol.png';
import imageSB from './images/sb_symbol.png';
import imageAuto from './images/automat_symbol.png';
import imageService from './images/zubehoer_symbol.png';

import { Grid, Row, Col, Breadcrumb} from 'react-bootstrap';

class overview extends Component {
  render() {
    return (
      <div className='container-fluid productMain'>
        <div className="BCMain">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Übersicht</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      <br/>
        <center><h1>Produkte</h1></center>
        <Grid className="productGrid">
            <Col xsHidden sm={6} md={3} lg={3} className="productItem">
              <div className="productCont">
                <Link to="/Suppliers/WuF">
                  <img src={imageWF} alt="Werkzeug- und Formenbau" className="productImg" />
                  <h4 >Werkzeug- und Formenbau</h4>
                  <hr/>
                  <p className="productText">Präzesionsfräsen, HSC-Fräsen, Senkerodieren, Flachschleifen, Messen und Spannmittel</p>
                </Link>
              </div>
            </Col>
            <Col xsHidden sm={6} md={3} lg={3} className="productItem">
              <div className="productCont">
                <Link to="/Suppliers/SuB">
                  <img src={imageSB} alt="Stahl- und Blechbearbeitung" className="productImg" />
                  <h4 >Stahlbau und Blechbearbeitung</h4>
                  <hr/>
                  <p className="productText">3D-Spannsysteme, Endgratung, Biegen und Schneiden</p>
                </Link>
              </div>
            </Col>
            <Col xsHidden sm={6} md={3} lg={3} className="productItem">
              <div className="productCont">
                <Link to="/Suppliers/Automatisierung">
                  <img src={imageAuto} alt="Automatisierung" className="productImg" />
                  <h4 >Automatisierung</h4>
                  <hr/>
                  <p className="productText">Vollautomatische Roboterautomation zur Verknüpfung von Fertigungstechnologien</p>
                </Link>
              </div>
            </Col>
            <Col xsHidden sm={6} md={3} lg={3} className="productItem">
              <div className="productCont">
                <Link to="/Suppliers/Zubehoer">
                  <img src={imageService} alt="Zubehoer" className="productImg" />
                  <h4 >Zubehör</h4>
                  <hr/>
                  <p className="productText">Heben, Fasen, Sprühen, Laserprojektion und Markieren</p>
                </Link>
              </div>
            </Col>
        </Grid>
        <Grid className="productGrid">
            <Col xs={6} smHidden mdHidden lgHidden className="productItem">
              <div className="productCont">
                <Link to="/Suppliers/WuF">
                  <img src={imageWF} alt="Werkzeug- und Formenbau" className="productImg" />
                  <h6 >Werkzeug- und Formenbau</h6>
                  <br/>
                </Link>
              </div>
            </Col>
            <Col xs={6} smHidden mdHidden lgHidden className="productItem">
              <div className="productCont">
                <Link to="/Suppliers/SuB">
                  <img src={imageSB} alt="Stahl- und Blechbearbeitung" className="productImg" />
                  <h6 >Stahlbau und Blechbearbeitung</h6>
                  <br/>
                </Link>
              </div>
            </Col>
            <Col xs={6} smHidden mdHidden lgHidden className="productItem">
              <div className="productCont">
                <Link to="/Suppliers/Automatisierung">
                  <img src={imageAuto} alt="Automatisierung" className="productImg" />
                  <h6 >Automatisierung</h6>
                  <br/>
                </Link>
              </div>
            </Col>
            <Col xs={6} smHidden mdHidden lgHidden className="productItem">
              <div className="productCont">
                <Link to="/Suppliers/Zubehoer">
                  <img src={imageService} alt="Zubehoer" className="productImg" />
                  <h6 >Zubehör</h6>
                  <br/>
                </Link>
              </div>
            </Col>
        </Grid>
        {/* <div className="upperMainDiv">
            <div className="left50Div"><Link to="/Suppliers/WuF"><img  src={imageWF} alt="..." /></Link></div>
            <div className="right50Div"><Link to="/Suppliers/SuB"><img  src={imageSB} alt="..." /></Link></div>
        </div>
        <div className="lowerMainDiv">
            <div className="left50Div"><Link to="/Suppliers/Automatisierung"><img  src={imageAuto} alt="..." /></Link></div>
            <div className="right50Div"><Link to="/Suppliers/Zubehoer"><img  src={imageService} alt="..." /></Link></div>
        </div> */}
        {/* <Grid>
          <Row className="show-grid">
            <Col xs={6}  sm={3}>
                <Link to="/Suppliers/WuF"><img  src={imageWF} alt="..." width="100%"/></Link>
              <h4 className="wordWrap">Werkzeug- und Formenbau</h4>
            </Col>
            <Col xs={6}  sm={3}>
                <Link to="/Suppliers/SuB"><img  src={imageSB} alt="..." width="100%"/></Link>
              <h4 className="wordWrap">Stahlbau und Blechbearbeitung</h4>
            </Col>
            <Col xsHidden  sm={3}>
                <Link to="/Suppliers/Automatisierung"><img  src={imageAuto} alt="..." width="100%"/></Link>
              <h4 className="wordWrap">Automatisierung</h4>
            </Col>
            <Col xsHidden  sm={3}>
                <Link to="/Suppliers/Zubehoer"><img  src={imageService} alt="..." width="100%"/></Link>
              <h4 className="wordWrap">Zubehör</h4>
            </Col>

          </Row>
          <br/>
          <Row className="show-grid">

            <Col xs={6}  smHidden mdHidden lgHidden>
                <Link to="/Suppliers/Automatisierung"><img  src={imageAuto} alt="..." width="100%"/></Link>
              <h4 className="wordWrap">Automatisierung</h4>
            </Col>
            <Col xs={6}  smHidden mdHidden lgHidden>
                <Link to="/Suppliers/Zubehoer"><img  src={imageService} alt="..." width="100%"/></Link>
              <h4 className="wordWrap">Zubehör</h4>
            </Col>

          </Row>
        </Grid> */}
        <br/>
      </div>

    );
  }
}

export default overview;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/overview.js